module.exports = __webpack_public_path__ + "img/lady_ethercluster.eb7f7544.png";